var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryContainers16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Containers_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Containers_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Containers_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Containers_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-7",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/Containers_16",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,13 L13,13 L13,8 L2,8 L2,13 Z M14,14 L13,14 L2,14 L1,14 L1,15 L14,15 L14,14 Z M1,7 L14,7 L14,6 L1,6 L1,7 Z M14,8 L14,13 L14.5,13 C14.776,13 15,13.224 15,13.5 L15,15.5 C15,15.776 14.776,16 14.5,16 L0.5,16 C0.224,16 0,15.776 0,15.5 L0,13.5 C0,13.224 0.224,13 0.5,13 L1,13 L1,8 L0.5,8 C0.224,8 0,7.776 0,7.5 L0,5.5 C0,5.321 0.099,5.172 0.239,5.084 L0.234,5.076 L5.354,1.872 L5.885,2.72 L2.242,5 L12.758,5 L9.115,2.72 L9.646,1.872 L14.766,5.076 L14.761,5.084 C14.901,5.172 15,5.321 15,5.5 L15,7.5 C15,7.776 14.776,8 14.5,8 L14,8 Z M7,3 L8,3 L8,0 L7,0 L7,3 Z M4,12 L5,12 L5,9 L4,9 L4,12 Z M10,12 L11,12 L11,9 L10,9 L10,12 Z M7,12 L8,12 L8,9 L7,9 L7,12 Z",
    id: "Fill-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryContainers16);
export default __webpack_public_path__ + "static/media/Arch-Category_Containers_16.565999534a0042ccb0b7e2796a6947eb.svg";
export { ForwardRef as ReactComponent };